"use client"

import { useState, useEffect } from "react"
import { Box, Container, Paper, Stepper, Step, StepLabel, Typography, ThemeProvider, createTheme } from "@mui/material"
import DistributionForm from "./DistributionTracker-Step1"
import SummaryStep from "./DistributionTracker-Step2"
import ConfirmationStep from "./DistributionTracker-Step3"



const theme = createTheme({
  palette: {
    primary: {
      main: "#1976d2",
    },
    secondary: {
      main: "#dc004e",
    },
  },
})

const steps = ["Distribution Details", "Review Information", "Confirmation"]

export default function Home() {

  const [activeStep, setActiveStep] = useState(0)
  const [distributionData, setDistributionData] = useState({
    supplier: "",
    supplierId: "",
    project: "",
    projectId: "",
    date: "",
    distributionStage: "",
    distributionStageId: "",
  })

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1)
  }

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1)
  }

  const handleReset = () => {
    setActiveStep(0)
    setDistributionData({
      supplier: "",
      supplierId: "",
      project: "",
      projectId: "",
      date: "",
      distributionStage: "",
      distributionStageId: "",
    })
  }

  const updateDistributionData = (data) => {
    setDistributionData(data)
  }






  const getStepContent = (step) => {
    switch (step) {
      case 0:
        return <DistributionForm data={distributionData} onDataChange={updateDistributionData} onNext={handleNext} />
      case 1:
        return <SummaryStep data={distributionData} onNext={handleNext} onBack={handleBack} />
      case 2:
        return <ConfirmationStep data={distributionData} onReset={handleReset} />
      default:
        return "Unknown step"
    }
  }


  

  return (
    <ThemeProvider theme={theme}>
      <Container maxWidth="md" sx={{ py: 4 }}>
        <Paper elevation={3} sx={{ p: 4 }}>
          <Typography variant="h4" component="h1" gutterBottom align="center">
            Distribution Management System
          </Typography>

          <Box sx={{ width: "100%", mt: 4 }}>
            <Stepper activeStep={activeStep} alternativeLabel>
              {steps.map((label) => (
                <Step key={label}>
                  <StepLabel>{label}</StepLabel>
                </Step>
              ))}
            </Stepper>

            <Box sx={{ mt: 4 }}>{getStepContent(activeStep)}</Box>
          </Box>
        </Paper>
      </Container>
    </ThemeProvider>
  )
}
